// src/Lexappstore/AppCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AppCard.css';

export default function AppCard({ id, title, description, imageUrl, link }) {
  const navigate = useNavigate();

  // 打开／使用
  const handleOpen = e => {
    e.stopPropagation();
    if (link.startsWith('http')) {
      window.open(link, '_blank', 'noopener');
    } else {
      navigate(link);
    }
  };

  // 进入详情页 —— 只有当 link 存在时才跳转
  const handleDetails = e => {
    e.stopPropagation();
    if (!link) return;        // <-- 关键：无 link 则不执行任何操作
    navigate(`/lexappstore/${id}`);
  };

  // 只有真正的 app 卡片才显示按钮
  const showActions = typeof link === 'string' && link.length > 0;

  return (
    <div className="appstore-card">
      {/* 右上角按钮，仅当有 link 时渲染 */}
      {showActions && (
        <div className="card-actions">
          <button
            className="action-btn open-btn"
            onClick={handleOpen}
            title="Open"
          >
            <span
            >
              ⏻
            </span>
          </button>
        </div>
      )}

      {/* 卡片主体，点击空白区判断后才跳详情 */}
      <div className="appstore-card-inner" onClick={handleDetails}>
        {imageUrl && (
          <div
            className="appstore-card-bg"
            style={{ backgroundImage: `url(${imageUrl})` }}
          />
        )}
        <h3 className="appstore-card-title">{title}</h3>
        <p className="appstore-card-desc">{description}</p>
      </div>
    </div>
  );
}
